import { Bitcoin } from "@interlay/monetary-js";
import Big from "big.js";
import { newMonetaryAmount } from ".";
const calculateTotalBorrowedBtcChange = (action, currentTotalBorrowedBtc, actionAmountBtc) => {
    switch (action) {
        case "borrow":
            return currentTotalBorrowedBtc.add(actionAmountBtc);
        case "repay":
            return currentTotalBorrowedBtc.sub(actionAmountBtc);
        default:
            return currentTotalBorrowedBtc;
    }
};
const calculateCollateralAmountBtcChange = (action, currentCollateralAmountBtc, actionAmountBtc) => {
    switch (action) {
        case "lend":
            return currentCollateralAmountBtc.add(actionAmountBtc);
        case "withdraw":
            return currentCollateralAmountBtc.sub(actionAmountBtc);
        default:
            return currentCollateralAmountBtc;
    }
};
const adjustToThreshold = (amount, threshold) => amount.mul(threshold);
const calculateBorrowLimit = (totalBorrowedAmount, totalCollateralThresholdAdjustedAmount) => totalCollateralThresholdAdjustedAmount.sub(totalBorrowedAmount).max(newMonetaryAmount(0, Bitcoin));
const getTotalAmountBtc = (positions, loanAssets) => positions.reduce((total, { amount }) => {
    const { exchangeRate } = loanAssets[amount.currency.ticker];
    const amountBtc = exchangeRate.toBase(amount);
    return total.add(amountBtc);
}, newMonetaryAmount(0, Bitcoin));
const calculateThreshold = (collateralAmount, thresholdAdjustedCollateralAmount) => {
    if (collateralAmount.toBig().eq(0)) {
        return Big(0);
    }
    return thresholdAdjustedCollateralAmount.toBig().div(collateralAmount.toBig());
};
const calculateLtv = (collateralAmount, borrowedAmount) => {
    if (collateralAmount.toBig().eq(0)) {
        return Big(0);
    }
    return borrowedAmount.toBig().div(collateralAmount.toBig());
};
const calculateBorrowLimitBtcChangeFactory = (loanAssets, totalBorrowedBtc, totalCollateralThresholdAdjustedCollateralBtc) => (action, amount) => {
    const { collateralThreshold, exchangeRate } = loanAssets[amount.currency.ticker];
    const amountBtc = exchangeRate.toBase(amount);
    const collateralThresholdAdjustedAmountBtc = adjustToThreshold(amountBtc, collateralThreshold);
    const newTotalBorrowedBtc = calculateTotalBorrowedBtcChange(action, totalBorrowedBtc, amountBtc);
    const newTotalCollateralThresholdAdjustedCollateralBtc = calculateCollateralAmountBtcChange(action, totalCollateralThresholdAdjustedCollateralBtc, collateralThresholdAdjustedAmountBtc);
    return calculateBorrowLimit(newTotalBorrowedBtc, newTotalCollateralThresholdAdjustedCollateralBtc);
};
const calculateLtvAndThresholdsChangeFactory = (loanAssets, totalBorrowedBtc, totalCollateralBtc, totalCollateralThresholdAdjustedCollateralBtc, totalLiquidationThresholdAdjustedCollateralBtc) => (action, amount) => {
    const { collateralThreshold, liquidationThreshold, exchangeRate } = loanAssets[amount.currency.ticker];
    const amountBtc = exchangeRate.toBase(amount);
    const collateralThresholdAdjustedAmountBtc = adjustToThreshold(amountBtc, collateralThreshold);
    const liquidationThresholdAdjustedAmountBtc = adjustToThreshold(amountBtc, liquidationThreshold);
    const newTotalBorrowedBtc = calculateTotalBorrowedBtcChange(action, totalBorrowedBtc, amountBtc);
    const newTotalCollateralBtc = calculateCollateralAmountBtcChange(action, totalCollateralBtc, amountBtc);
    const newTotalCollateralThresholdAdjustedCollateralBtc = calculateCollateralAmountBtcChange(action, totalCollateralThresholdAdjustedCollateralBtc, collateralThresholdAdjustedAmountBtc);
    const newTotalLiquidationThresholdAdjustedCollateralBtc = calculateCollateralAmountBtcChange(action, totalLiquidationThresholdAdjustedCollateralBtc, liquidationThresholdAdjustedAmountBtc);
    const ltv = calculateLtv(newTotalCollateralBtc, newTotalBorrowedBtc);
    const collateralThresholdWeightedAverage = calculateThreshold(newTotalCollateralBtc, newTotalCollateralThresholdAdjustedCollateralBtc);
    const liquidationThresholdWeightedAverage = calculateThreshold(newTotalCollateralBtc, newTotalLiquidationThresholdAdjustedCollateralBtc);
    return {
        ltv,
        collateralThresholdWeightedAverage,
        liquidationThresholdWeightedAverage,
    };
};
export { calculateBorrowLimit, adjustToThreshold, calculateCollateralAmountBtcChange as calculateCollateralAmountBtc, calculateTotalBorrowedBtcChange, getTotalAmountBtc, calculateLtv, calculateThreshold, calculateBorrowLimitBtcChangeFactory, calculateLtvAndThresholdsChangeFactory, };
//# sourceMappingURL=loans.js.map